module.exports = __webpack_public_path__ + "static/media/6.9d29cc59.webp";